import React from "react";
/* Components */
import {Layout} from "layouts";
import {Header, Videos, RadioInterviews, Articles} from "@/components/pages/media"

const Media: React.FC = () => {
    return <Layout page={"media"}>
        <Header/>
        <Videos/>
        <RadioInterviews/>
        <Articles/>
    </Layout>
}

export default Media